(ns ycweb.app.dashboard.warehouse.common
  (:require
    [rum.core :as rum]
    [ycweb.components.common :as cmn]
    [ycweb.weber.common :as w.cmn]
    [ycweb.util.core :as u]
    [ycweb.components.grid :as grid]
    [util.string :as str]))

(def weber-link "https://weber.yuppiechef.com")

(defn generate-cols-from-keys
  "Generates a probable header row from key-order."
  [key-order]
  (into [] (map (fn [k] {:title (str/capitalize (name k)) :keyfn k}) key-order)))

(rum/defc barcode-text [code text]
  [:span.barcode-span
   [:img.barcode
    {:src (str weber-link "/barcode/" code)}]
   (when (u/presence text)
     [:br]
     [:span.barcode-name
      {:style {:margin-left "10px"}}
      text])])

(defn tab [name content & [id]]
  {:name name
   :id (or id (w.cmn/idfy (str "tab_" name)))
   :content content})

(defn tab-url [name url]
  {:name name
   :id (w.cmn/idfy (str "tab_" name))
   :content [(w.cmn/loadimg) " Loading..."]
   :url url})

(defn tab-action [name action]
  {:name name
   :id (w.cmn/idfy (str "tab_" name))
   :content [(w.cmn/loadimg) " Loading..."]
   :action action})

;;TODO: Frontend team to create classes for tabs
(defn tab-link [name url for-tab current]
  [:li
   {:class
    (u/bem :nav-item
      [(when current
        :active)])
    :style
    {:display "list-item"
     :text-align "-webkit-match-parent"}}
   [:a
    {:on-click url
     :fortab for-tab
     :style
     {:background "0 0"
      :border-width "1px"
      :border-style "solid"
      :border-color (if current "#dee2e6 #dee2e6 #fff" "transparent transparent #dee2e6 transparent")
      :border-top-left-radius "0.25rem"
      :border-top-right-radius "0.25rem"
      ;;
      :display "block"
      :padding ".5rem 1rem"
      :color (if current "#495057" "#0d6efd")
      :background-color "#fff"
      :text-decoration "none"
      :transition "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out"}}
    name]])

(defn tab-grid-action [name action for-tab current]
  [:li
   {:class
    (u/bem :nav-item
      [(when current
         :active)])
    :style
    {:display "list-item"
     :text-align "-webkit-match-parent"}}
   [:a
    {:on-click action
     :fortab for-tab
     :style
     {:background "0 0"
      :border-width "1px"
      :border-style "solid"
      :border-color (if current "#dee2e6 #dee2e6 #fff" "transparent transparent #dee2e6 transparent")
      :border-top-left-radius "0.25rem"
      :border-top-right-radius "0.25rem"
      ;;
      :display "block"
      :padding ".5rem 1rem"
      :color (if current "#495057" "#0d6efd")
      :background-color "#fff"
      :text-decoration "none"
      :transition "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out"}}
    name]])

(defn tab-nav [local-atom name for-tab current]
  [:li
   {:class
    (u/bem :nav-item
      [(case current
         :active)])
    :style
    {:display "list-item"
     :text-align "-webkit-match-parent"}}
   [:a
    {:on-click #(swap! local-atom assoc :active for-tab)
     :style
     {:background "0 0"
      :border-width "1px"
      :border-style "solid"
      :border-color (if current "#dee2e6 #dee2e6 #fff" "transparent transparent #dee2e6 transparent")
      :border-top-left-radius "0.25rem"
      :border-top-right-radius "0.25rem"
      ;;
      :display "block"
      :padding ".5rem 1rem"
      :color (if current "#495057" "#000")
      :background-color "#fff"
      :text-decoration "none"
      :transition "color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out"}}
    name]])

(rum/defcs
  tabbed-content <
  rum/reactive
  (rum/local nil ::local)
  [s title description tabs]
  (let [local-atom (::local s)
        first-tab (first tabs)
        active-tab (cmn/curact local-atom :active)

        _
        (when (nil? active-tab)
          (swap! local-atom assoc :active (:id first-tab)))

        {:keys [id url content] :as tab}
        (->>
          tabs
          (remove nil?)
          (remove :url)
          (filter #(= active-tab (:id %)))
          (first))]

    [:div.centercontent.notab
     [:div.pageheader
      [:h2.pagetitle title]
      [:span.pagedesc description]]

     [:div.contentwrapper

      [:div.tabs
       (into
         [:ul
          {:style
           {:display "flex"
            :flex-wrap "wrap"
            :padding-left "0px"
            :margin-bottom "20px"
            :list-style "none"}}]
         (map
           (fn [{:keys [name url action id] :as tab}]
             (cond
               url
               (tab-link name (if url url (str "#" id)) id (= id active-tab))

               action
               (tab-grid-action name action id (= id active-tab))

               :else
               (tab-nav local-atom name id (= id active-tab))))
           tabs))
       (into
         [:div.subcontent
          {:id id
           :loaded (if url "false" "true")}]
         (let [[fst & more] content]
           (if (keyword? fst) [content] content)))]]]))